import { StrictMode } from "react";
import ReactDOM from "react-dom/client";

import {
  addSWInfoMessageListener,
  PHANTOM_USER_MESSAGE_TYPES,
  sendPhantomUserMessage,
  SW_INFO_MESSAGE_TYPES,
} from "@lib/sw.helpers";
import { initIcons } from "@src/assets/icons";
import { Router } from "@src/router";
import { initObservability } from "./observability";

import "./index.scss";

initObservability();
initIcons();

ReactDOM.createRoot(document.querySelector("#root")).render(
  <StrictMode>
    <Router />
  </StrictMode>,
);

// Make sure service worker data is reset on load
sendPhantomUserMessage(PHANTOM_USER_MESSAGE_TYPES.refresh);

addSWInfoMessageListener(({ data: { type, payload } }) => {
  if (type === SW_INFO_MESSAGE_TYPES.error) {
    new Notification(payload);
  } else if (type === SW_INFO_MESSAGE_TYPES.update) {
    // TODO notify user that app has updated
  }
});

try {
  await navigator.serviceWorker.ready;
  // Check if the service worker is controlling the page
  if (!navigator.serviceWorker.controller) {
    // If no service worker, force a reload.
    window.location.reload();
  }
} catch (error) {
  console.error("Service worker registration failed:", error);
}

if (import.meta.env.DEV) {
  // permissions can only be requested in response to a user interaction, so
  // we'll request with the first click
  window.addEventListener("click", () => {
    Notification.requestPermission();
  });
}
